/* Preserve the background film without competing with the first visible frame. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-hnk-background-video]').forEach((wrapper) => {
      if (wrapper.dataset.hnkReady) return;
      const video = wrapper.querySelector('video');
      const button = wrapper.querySelector('.hnk-video-toggle');
      if (!video || !button) return;
      wrapper.dataset.hnkReady = 'true';
      button.hidden = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      let loaded = false;
      let visible = false;
      let interacted = false;

      const play = () => {
        if (!loaded) {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
          });
          video.load();
          loaded = true;
        }
        video.play().catch(() => {
          wrapper.classList.remove('is-playing');
          button.textContent = '動画を再生';
          button.setAttribute('aria-label', '背景動画を再生');
          button.setAttribute('aria-pressed', 'false');
        });
      };
      video.addEventListener('playing', () => {
        wrapper.classList.add('is-playing');
        button.textContent = '動画を停止';
        button.setAttribute('aria-label', '背景動画を停止');
        button.setAttribute('aria-pressed', 'true');
      });
      video.addEventListener('pause', () => {
        button.textContent = '動画を再生';
        button.setAttribute('aria-label', '背景動画を再生');
        button.setAttribute('aria-pressed', 'false');
      });
      button.addEventListener('click', () => {
        interacted = true;
        if (video.paused) play();
        else video.pause();
      });

      // Motion-sensitive and data-saving visitors get an explicit play button.
      if (!reducedMotion.matches && !connection?.saveData && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting;
          if (!visible && loaded) video.pause();
          else if (visible && interacted && !loaded) play();
        });
        observer.observe(wrapper);
        const onScroll = () => {
          if (!wrapper.isConnected) {
            window.removeEventListener('scroll', onScroll);
            observer.disconnect();
            return;
          }
          if (window.scrollY < 40) return;
          interacted = true;
          window.removeEventListener('scroll', onScroll);
          if (visible) play();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
